import React from 'react';

export const PictureIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H44V44H0V0Z" fill="white" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41693 8.98384C6.31567 8.98384 6.23359 9.06592 6.23359 9.16717V34.8338C6.23359 34.9351 6.31568 35.0172 6.41693 35.0172H37.5836C37.6848 35.0172 37.7669 34.9351 37.7669 34.8338V9.16717C37.7669 9.06592 37.6848 8.98384 37.5836 8.98384H6.41693ZM2.93359 9.16717C2.93359 7.24338 4.49314 5.68384 6.41693 5.68384H37.5836C39.5074 5.68384 41.0669 7.24338 41.0669 9.16717V34.8338C41.0669 36.7576 39.5074 38.3172 37.5836 38.3172H6.41693C4.49313 38.3172 2.93359 36.7576 2.93359 34.8338V9.16717Z"
        fill="#555555"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2949 15.9092C13.7275 15.9092 14.0782 15.5586 14.0782 15.126C14.0782 14.6934 13.7275 14.3428 13.2949 14.3428C12.8624 14.3428 12.5117 14.6934 12.5117 15.126C12.5117 15.5586 12.8624 15.9092 13.2949 15.9092ZM9.76172 15.126C9.76172 13.1747 11.3436 11.5928 13.2949 11.5928C15.2463 11.5928 16.8282 13.1747 16.8282 15.126C16.8282 17.0773 15.2463 18.6592 13.2949 18.6592C11.3436 18.6592 9.76172 17.0773 9.76172 15.126Z"
        fill="#555555"
      />
      <path
        d="M13.7487 22.0005L18.332 25.6672L23.832 19.2505L39.4154 31.1672V34.8338C39.4154 35.8463 38.5946 36.6672 37.582 36.6672H6.41536C5.40284 36.6672 4.58203 35.8463 4.58203 34.8338V31.1672L13.7487 22.0005Z"
        fill="#2F88FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5808 18.1768C23.1506 17.5121 24.1404 17.4081 24.8359 17.9399L40.4192 29.8566C40.8275 30.1688 41.0669 30.6534 41.0669 31.1673V34.834C41.0669 36.7578 39.5074 38.3173 37.5836 38.3173H6.41693C4.49314 38.3173 2.93359 36.7578 2.93359 34.834V31.1673C2.93359 30.7297 3.10743 30.31 3.41687 30.0006L12.5835 20.8339C13.178 20.2394 14.1245 20.187 14.781 20.7122L18.1188 23.3825L22.5808 18.1768ZM24.0708 21.5092L19.5864 26.7411C19.0075 27.4165 17.9974 27.5114 17.3028 26.9557L13.8727 24.2116L6.23359 31.8508V34.834C6.23359 34.9352 6.31567 35.0173 6.41693 35.0173H37.5836C37.6848 35.0173 37.7669 34.9352 37.7669 34.834V31.9827L24.0708 21.5092Z"
        fill="#555555"
      />
    </svg>
  );
};
